<template>
  <div class="sa-list-component">
    <div class="sa-list-component-header">
      <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col lg="3">
          <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col lg="9">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </div>
    <div class="sa-list-component-body">
      <b-table sticky-header striped hover ref="table" stacked="lg" :items="magazziniItems" :fields="fieldMagazzino" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
        <template #cell(descrizioneMagazzino)="row">
          <span style="font-weight: 600">{{ row.item.descrizioneMagazzino }} </span> <span style="font-weight: 400">({{ row.item.codiceMagazzino }})</span>
        </template>
        <template #cell(actions)="row">
          <b-button size="sm" v-b-tooltip.hover title="Visualizza Magazzino" variant="outline-secondary" @click="onClickSelezionaVisualizzaMagazzino(row)">
            <font-awesome-icon icon="eye" />
          </b-button>
        </template>
      </b-table>
    </div>
    <div class="sa-list-component-footer">
      <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
        <b-col lg="3">
          <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
        </b-col>
        <b-col lg="9">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  name: "MagazzinoArticoliTabStoricoContabileComponent",
  mixins: [UtilityMixin],
  props: {},
  components: {},
  mounted() {
    //let me = this;
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      rows: 0,
      fieldMagazzino: [
        {
          label: "Magazzino",
          key: "descrizioneMagazzino",
          sortable: true,
        },
        {
          label: "Tipo",
          key: "tipo",
          sortable: true,
        },
        { class: "sa-table-column-action-double", key: "actions", label: "" },
      ],
      jsonData: {},
      magazziniItems: [],
      pathResouce: "/magazzinomagazzini",
    };
  },
  methods: {
    init(filtro) {
      let me = this;
      me.loadMagazzini(filtro);
    },
    onClickSelezionaVisualizzaMagazzino(row) {
      this.$router.push("/magazzino/magazzini/" + row.item.id);
    },
    loadMagazzini(filtro) {
      let me = this;
      me.$emit("beforeLoadData");
      UtilityMixin.methods.loadDataResources(me.pathResouce, filtro, me.loadMagazziniSuccess, me.loadMagazziniError);
    },
    loadMagazziniSuccess(response) {
      let me = this;
      me.rows = response.data.data.recordsNumber;
      me.magazziniItems = response.data.data.list;

      me.$emit("afterLoadData");
    },
    loadMagazziniError(error) {
      let me = this;
      console.log(error);
      me.$emit("afterLoadData");
    },
  },
};
</script>
